export enum TopMessagesType {
    HighestMessages = 0,
    Establishments = 1,
    PendingMessages = 2,
    LogLevelEstablishments = 3
}
